import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function LineArrowDownIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="M12 5v14" />
      <path d="m19 12-7 7-7-7" />
    </StrokeIcon>
  );
}
